export default {
  cancel: 'Cancel',
  close: 'Close',
  ok: 'OK',
} as const;
